import React from 'react';
import AuthenticationLayout from '../../componentsV2/Layouts/AuthenticationLayout';
import ResetPasswordForm from './components/ResetPasswordForm';

const ResetPasswordPage: React.FC = () => {
  return <AuthenticationLayout leftSide={<ResetPasswordForm />} rightSide={<p></p>} />;
};

export default ResetPasswordPage;
